export default "__VITE_ASSET__ZMJY2KeN__"